<template>
    <div class="page">
        <header class="header">
            <img class="myNiubiLogo" src="~@/assets/my-niubi-logo.png" alt="" />
            <div class="title">现有牛币</div>
            <div class="niubiNum">{{ myGold }}</div>
            <span class="rechargeBtn" @click="showRecharge()">充值</span>
        </header>
        <div class="fg"></div>
        <div class="niubi-detail">
            <div class="title">
                <span>牛币明细</span>
                <img class="down-arrow" src="~@/assets/left-arrow.png" alt="" />
            </div>
            <div class="list">
                <div class="item" v-for="item in list" :key="item.id">
                    <div class="left">
                        <div class="sub-title">{{ item.gift_name }}</div>
                        <div class="time">{{ item.create_time }}</div>
                    </div>
                    <div
                        class="right "
                        :class="[item.pay_gold > 0 ? 'add' : 'reduce']"
                    >
                        {{ item.pay_gold }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import userCenterService from "../../service/user-center.service";
import rx from "../../_rx";
export default {
    name: "recharge",
    data() {
        return {
            list: [],
            myGold: 0
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        showRecharge() {
            rx.emit("showChongzhi");
        },
        init() {
            userCenterService.getGoldPayList().then(res => {
                this.myGold = res.data.myGold;
                this.list = res.data.list;
            });
        }
    }
};
</script>

<style lang="scss" scoped src="./niubi-detail.scss">
</style>